import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-sb-roerende-zaken',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-roerende-zaken.component.html',
  styleUrl: './tekst-roerende-zaken.component.scss',
})
export class TekstRoerendeZakenComponent {}
